import { sendRequest } from "../../hooks/requests/useRequest";

export async function validateAuthorization({
    accessUser ,id_mic_detail_sample
}) {
  
    let body = {
        accessUser:accessUser,
        id_mic_detail_sample:id_mic_detail_sample,
    };
    
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, `TrackingMicro/AuthorizationSample`
    );

  if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return {
            code: response.code,
            data: response.data
    } 
    else
        return {
            code: response.code,
            msg: response?.data?.msg
        };
}
